import React, { useState } from "react";
import "./Spin_Wheel_holder.css";

function Spin_Wheel_holder() {
  const [rotation, setRotation] = useState(0);
  const [spinning, setSpinning] = useState(false);

  const handleSpin = () => {
    if (spinning) return;

    const extraSpin = 3600 + Math.floor(Math.random() * 360);
    const newRotation = rotation + extraSpin;

    setRotation(newRotation);
    setSpinning(true);

    setTimeout(() => {
      setSpinning(false);
    }, 4000);
  };

  return (
    <section className="Spin_Wheel_holder">
      <div className="bg_holder">
        <img src="/assets/images/invite_wheel/wheen_bg.png" className="bg_img" />
      </div>

      <div className="stand_holder">
        <img src="/assets/images/invite_wheel/stand.png" className="stand_img" />
      </div>

      <div className="wheel_holder">
        <div className="wheel_spin_holder">

          {/* ✅ Wheel */}
          <img
            src="/assets/images/invite_wheel/wheel.png"
            className="wheel_img"
            style={{ transform: `rotate(${rotation}deg)` }}
            alt="wheel"
          />

          {/* ✅ Button */}
          <img
            src="/assets/images/invite_wheel/spin_btn.png"
            className="Spin_Btn_img"
            onClick={handleSpin}
            alt="spin"
          />
        </div>
      </div>
    </section>
  );
}

export default Spin_Wheel_holder;